﻿(function($) {

	$.widget('lb.justify', {
		options: {
			selector: undefined
		},
		_create: function() {
			var maxHeight = 0;

			var elements;
			if (this.options.selector) {
				elements = this.element.find(this.options.selector);
			} else {
				elements = this.element.children();
			}
			
			elements.each(function() {
				var height = $(this).height();
				if (height > maxHeight) { maxHeight = height; }
			}).each(function() {
				$(this).height(maxHeight);
			});
		}
	});

})(jQuery);